import './DangXuat.scss'
import { useState } from 'react'
import { PopPupChung } from '../../../component/PopPupChung'
function DangXuat ({ showLogoutPopup, setShowLogoutPopup }) {
  const [animateOut, setAnimateOut] = useState(false)

  const handleLogout = () => {
    localStorage.clear()
    window.location.href = '/'
  }

  const handleClose = () => {
    setAnimateOut(true)
  }

  return (
    <PopPupChung
      isOpen={showLogoutPopup}
      setisOpen={setShowLogoutPopup}
      animateOut={animateOut}
      setAnimateOut={setAnimateOut}
    >
      <h3>Đăng xuất</h3>
      <p>Bạn chắc chắn muốn đăng xuất?</p>
      <div className='popup_actions_logout'>
        <button className='cancel_btn_logout' onClick={handleClose}>
          Hủy bỏ
        </button>
        <button className='confirm_btn_logout' onClick={handleLogout}>
          Xác nhận
        </button>
      </div>
    </PopPupChung>
  )
}

export default DangXuat
